module.exports = __webpack_public_path__ + "static/assets/dfbb39e23cc145ee19acbce33b912353.jpg";